import { ExclamationCircleIcon } from '@heroicons/react/24/solid'
import { FC, useState } from 'react'

import { useDeleteUserContact } from '@/api/models/users'
import { AppButton } from '@/components/shared/button'
import { ConfirmSubmitModal } from '@/components/shared/modal'

type Props = {
  contactId: string
  isRevocable: boolean
  onSuccess?: () => void
  onError?: () => void
}

const CloseContactAccess: FC<Props> = ({
  contactId,
  isRevocable,
  onSuccess,
  onError
}) => {
  const { mutateAsync: deleteUserContact, isPending } = useDeleteUserContact()

  const [isCloseAccessModalOpened, setIsCloseAccessModalOpened] =
    useState(false)

  const handleDeleteUserContact = () => {
    deleteUserContact(contactId).then(onSuccess).catch(onError)
  }

  if (!isRevocable) {
    return (
      <div className="flex items-center justify-center gap-4 text-center font-bold text-18 xxs:text-16">
        <ExclamationCircleIcon width={16} height={16} />
        <p>Вам недоступна функция закрытия доступа для данного аккаунта</p>
      </div>
    )
  }

  return (
    <>
      <AppButton
        fluid
        variant="backless"
        size="large"
        loading={isPending}
        className="!text-red-80 sm:!h-44"
        onClick={() => setIsCloseAccessModalOpened(true)}
      >
        {isPending || 'Закрыть доступ'}
      </AppButton>

      <ConfirmSubmitModal
        opened={isCloseAccessModalOpened}
        header="Закрыть доступ"
        message="Вы точно хотите закрыть доступ для этого аккаунта? Отменить данное действие будет невозможно."
        closeButtonText="Отмена"
        submitButtonText="Закрыть доступ"
        submitButtonClassName="!bg-red-80 !border-red-80"
        onClose={() => setIsCloseAccessModalOpened(false)}
        onSubmit={handleDeleteUserContact}
      />
    </>
  )
}

export default CloseContactAccess
